<template>
  <div>
    <p class="text-center m-0 accept-text">
      {{ t("BY_CLICKING_CONTINUE_YOU_ACCEPT") }}
      <a class="pj-link-green" @click="showPrivacyModal = true">{{
        t("PRIVACY_POLICY")
      }}</a>
      {{ t("AND_") }}
      <a class="pj-link-green" @click="showTermsModal = true">{{
        t("TERMS_AND_CONDITIONS")
      }}</a>
    </p>
  </div>

  <div class="px-3">
    <Modal :show="showPrivacyModal">
      <template #header>
        <div class="d-flex flex-fill w-100 p-0">
          <span class="ms-auto me-0 right p-0" @click="showPrivacyModal = false"
            ><i class="fa fa-times" style="font-size: larger !important"></i
          ></span>
        </div>
        <div class="d-flex flex-row">
          <h5
            class="text-black fw-bolder text-center me-1 w-100"
            id="modal-title-header"
          >
            {{ t("PRIVACY_POLICY") }}
          </h5>
        </div>
      </template>
      <template #body class="mt-2">
        <div
          class="content p-2 mt-2"
          :class="{ 'fs-3': styleForSelfService }"
          v-html="privacyPolicyContent"
        ></div>
      </template>

      <template #confirm>OK</template>
    </Modal>

    <Modal :show="showTermsModal" :showCancelButton="false">
      <template #header>
        <div class="d-flex flex-fill w-100 p-0">
          <span class="ms-auto me-0 right p-0" @click="showTermsModal = false"
            ><i class="fa fa-times" style="font-size: larger !important"></i
          ></span>
        </div>

        <div class="d-flex flex-row">
          <h5
            class="text-black fw-bolder text-center me-1 w-100"
            id="modal-title-header"
          >
            {{ t("TERMS_AND_CONDITIONS") }}
          </h5>
        </div>
      </template>
      <template #body class="mt-2">
        <div
          class="content p-2 mt-2"
          :class="{ 'fs-3': styleForSelfService }"
          v-html="termsContent"
        ></div>
      </template>
      <template #confirm>OK</template>
    </Modal>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "@/apps/merchant3/composables/useI18n";
import { useTermsAndPrivacyContent } from "@/apps/merchant3/hooks/useTermsAndPrivacyContent";
import { ref } from "vue";
import Modal from "@/apps/merchant3/shared-components/credit-line/Modal.vue";

const { t } = useI18n();

const props = defineProps<{
  locale: string;
  cartTag?: string;
  styleForSelfService?: boolean;
}>();

const { privacyPolicyContent, termsContent } = useTermsAndPrivacyContent(
  props.locale,
  props.cartTag
);

const showPrivacyModal = ref(false);
const showTermsModal = ref(false);
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

.accept-text {
  font-size: 12px;
}

.content {
  border: 1px solid $pj-color-green;
  height: 50vh;
  overflow-y: auto;
  text-align: left;
  border-radius: 8px;
  font-size: 14px;
}

:deep(.modal-confirm-container) {
  box-sizing: border-box;
  max-width: 100%;
}

:deep(.modal-confirm-body) {
  max-width: 100% !important;
  overflow-x: hidden;
}

.content :deep(*) {
  max-width: 100%;
  overflow-wrap: break-word;
  word-break: break-word;
}
</style>
